// src/components/shared/hooks/useAirports.js
import { useEffect, useMemo, useState } from "react";
import { SERVER_URL } from "../../../constants"; // adjust relative path to your constants

export function useAirports({ activeOnly = true } = {}) {
  const [airports, setAirports] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const token = () => sessionStorage.getItem("bearer");

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await fetch(`${SERVER_URL}api/airports`, {
          headers: { Authorization: `Bearer ${token()}` },
        });
        if (!res.ok) throw new Error(`airports HTTP ${res.status}`);
        const data = await res.json();

        const list = Array.isArray(data) ? data : [];
        const filtered = activeOnly ? list.filter((a) => a.active) : list;

        // sortOrder first, then name
        filtered.sort((a, b) => {
          const sa = Number(a.sortOrder ?? 9999);
          const sb = Number(b.sortOrder ?? 9999);
          if (sa !== sb) return sa - sb;
          return String(a.name || "").localeCompare(String(b.name || ""));
        });

        if (!cancelled) setAirports(filtered);
      } catch (e) {
        console.error("Failed to load airports", e);
        if (!cancelled) {
          setError(e);
          setAirports([]);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, [activeOnly]);

  const byCode = useMemo(() => {
    const map = new Map();
    airports.forEach((a) => map.set(a.code, a));
    return map;
  }, [airports]);

  return { airports, byCode, loading, error };
}